export default __webpack_public_path__ + "e1c718b48163121fff540ad5532217fa.png";